module.exports = __webpack_public_path__ + "static/media/gf.333751e5.svg";